export default "__VITE_ASSET__52784880__"